import MaterialTable from '@material-table/core'
import {
	Avatar,
	Button,
	Card,
	CardContent,
	CardHeader,
	Chip,
	Link,
	Typography,
	Collapse,
	Tooltip,
	Icon,
	CircularProgress
} from '@material-ui/core'
import { Warning } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { cloneDeep, groupBy, isEmpty, isEqual } from 'lodash'
import moment from 'moment'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link as RouterLink } from 'react-router-dom'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { dogAlert } from '../../services/theme'
import { updateVisit, updateVisitAddOns } from '../../actions/visits/visits.actions'
import { api } from '../../services/api'
import { getAvatarLetters, getChipStyles, getPetAge, getDogIssues } from '../../services/helpers'
import { ADDON_ONLY, GROOMING, GROOMING_DEFAULT_EMPTY_VALUE } from '../../utils'
import { USER_ROLES } from '../../utils/enums'
import { ApplyAddOnDialog } from '../Dialogs'
import {
	EditAssignmentsDialog,
	EditFoodDialog,
	EditInventoryDialog,
	EditMedsDialog,
	GroomingDialog,
	GroomingReportDialog,
	GroomingServiceDialog,
	PhotoDialog
} from '../Dialogs/Visit'
import RelatedVisitsTable from '../Tables/RelatedVisitsTable'
import EditMedDialog from '../Dialogs/Visit/EditMedDialog'
import GroomingAddOnDropdown from './GroomingAddOnDropdown'
import VisitPetDetailDayDropdown from './VisitPetDetailDayDropdown'
import GroomingDurationTable from '../Tables/GroomingDurationTable'
import ToolTipItemPet from './ToolTipItemPet'
import useConstants from '../../hooks/useConstants'
import StaffNotesVisit from '../StaffNotes/StaffNotesVisit'
import ClientNotes from './ClientNotes'

const useStyles = makeStyles((theme) => ({
	cardHeader: {
		'& .MuiCardHeader-title': {
			color: theme.palette.secondary.main
		}
	},
	box: {
		border: '1px solid #E5E5E5',
		borderRadius: '6px',
		marginBottom: '8px'
	},
	boxHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '16px'
	},
	editButton: {
		color: '#6B4AD6',
		fontWeight: '600px',
		fontSize: '16px',
		textTransform: 'capitalize'
	},
	sectionsWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		marginBottom: '24px'
	},
	row: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		padding: '16px',
		paddingTop: '0'
	},
	section: {
		width: '210px'
	},

	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	row: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		paddingBottom: 16,
		paddingLeft: 16
	},
	addOnButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	petTitle: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		'& a': {
			fontSize: '16px',
			lineHeight: '22px'
		}
	},
	checkedInOutChip: {
		marginLeft: '16px',
		'& .MuiChip-label': {
			marginRight: 0
		}
	},
	bodyCheckLink: {
		display: 'flex',
		alignItems: 'center',
		'& i': {
			fontSize: '16px',
			marginRight: '16px',
			color: '#6B4AD6',
			lineHeight: '20px'
		},
		'&:hover': {
			textDecoration: 'none'
		}
	},
	titleText: {
		paddingBottom: 8,
		color: '#1A1A35',
		fontSize: '16px',
		fontWeight: '600px'
	},
	infoText: {
		paddingBottom: 8,
		color: '#4D4C4F',
		fontSize: '16px',
		fontWeight: '600px'
	},
	rowInt: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		paddingLeft: 16,
		paddingBottom: 24
	},
	rowRow: {
		width: 220,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	rowRow2: {
		width: 600,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	serviceText: {
		fontSize: 16,
		fontWeight: '600',
		color: '#1a1a35'
	},
	serviceText2: {
		fontSize: 16,
		fontWeight: '600',
		color: '#4D4C4F'
	},
	serviceText2OneLine: {
		fontSize: 16,
		fontWeight: '600',
		color: '#4D4C4F'
	}
}))

const VisitPetDetail = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const user = useSelector((state) => state.general?.user?.user)
	const canEditExtraGroomTime =
		user?.roles?.includes(USER_ROLES.BackOfficeUser) ||
		user?.roles?.includes(USER_ROLES.SuperUser) ||
		false
	const { pet, visit, staffList, household } = props
	const { tags } = useConstants()
	// const staff_notes = visit && visit.staff_notes ? visit.staff_notes : []
	const [isShown, setIsShown] = useState(false)
	const [isEditAssignmentsShown, setIsEditAssignmentsShown] = useState(false)
	const [isEditFoodShown, setIsEditFoodShown] = useState(false)
	const [isEditMedsShown, setIsEditMedsShown] = useState(false)
	const [isEditMedShown, setIsEditMedShown] = useState(false)
	const [selectedMed, setSelectedMed] = useState(null)
	const [isEditInventoryShown, setIsEditInventoryShown] = useState(false)
	const [petSensitivityTags, setPetSensitivityTags] = useState([])
	const [petGroomingTags, setPetGroomingTags] = useState([])
	const [isGroomingEditShown, setIsEditGroomingShown] = useState(false)
	const [isGroomingReportShown, setIsGroomingReportShown] = useState(false)
	const [isServiceShown, setIsServiceShown] = useState(false)
	const [refPhoto, showRefPhoto] = useState(false)
	const [photoUrl, setPhotoUrl] = useState('')
	const [photoType, setPhotoType] = useState('')
	const [selectedMeds, setSelectedMeds] = useState([])
	const [initialMeds, setInitialMeds] = useState([])
	const [notAvailableMeds, setNotAvailableMeds] = useState([])
	const [showGroomTable, setShowGroomTable] = useState(false)

	const [visitMeds, setVisitMeds] = useState([])
	const [updatedMeds, setUpdatedMeds] = useState([])

	const [dailyMeds, setDailyMeds] = useState([])
	const [updatedDailyMeds, setUpdatedDailyMeds] = useState([])

	const facility = useSelector((state) => state.specific.facilities.selected)
	const facilities = useSelector((state) => state.specific.facilities.facilities)
	const playgroups = (facility && facility.playgroups) || []

	const isWelcomeDay = visit?.welcome_day_pets?.includes(pet?._id)
	const isAddonOnlyVisit = visit?.type === ADDON_ONLY

	useEffect(() => {
		if (tags && pet?.tags && pet.tags.sensitivity && pet.tags.sensitivity.length) {
			let sensitivityTags = tags.sensitivity.filter((tag) => {
				return pet.tags.sensitivity.findIndex((pt) => pt._id === tag._id) !== -1
			})

			setPetSensitivityTags(sensitivityTags)
		} else {
			setPetSensitivityTags([])
		}

		if (tags && pet?.tags && pet.tags.grooming && pet.tags.grooming.length) {
			let groomingTags = tags.grooming.filter((tag) => {
				return pet.tags.grooming.findIndex((pt) => pt._id === tag._id) !== -1
			})

			setPetGroomingTags(groomingTags)
		} else {
			setPetGroomingTags([])
		}
	}, [tags, pet])

	const groomingPrices = useMemo(() => {
		if (visit?._id && facilities?.length) {
			const ourFacility = facilities.find((f) => f._id == visit.facility_id)
			return ourFacility?.groomingPricing
		}

		return {}
	}, [facility])

	const visitFacility = useMemo(() => {
		if (visit?._id && facilities?.length) {
			const ourFacility = facilities.find((f) => f._id == visit.facility_id)
			return ourFacility
		}

		return null
	}, [facility])

	useEffect(() => {
		if (visit && visit.medications && pet && pet.medication) {
			let dailyMeds =
				pet.medication && pet.medication.length
					? pet.medication
						.filter((m) => m.active !== false && m.frequency === 'Daily')
						.map((m) => {
							let found = visit.medications.find(
								(vm) => vm.med_id === m._id && vm.frequency === m.frequency
							)

							return (
								found || {
									med_id: m._id,
									name: m.name,
									pet_id: pet._id,
									frequency: m.frequency,
									times_of_day: m.times_of_day
								}
							)
						})
					: []

			let medications = [...visit.medications.filter((m) => !m.frequency)]

			medications = groupBy(medications, 'date')

			medications = Object.keys(medications)
				.map((m) => {
					let meds = cloneDeep(medications[m])

					meds = groupBy(meds, 'med_id')

					return Object.keys(meds).map((med) => {
						let currentMeds = cloneDeep(meds[med])

						return {
							med_id: med,
							date: m,
							name: currentMeds[0].name,
							time_blocks: currentMeds.map((currentMed) => currentMed.time)
						}
					})
				})
				.flat(1)

			setVisitMeds(medications)
			setUpdatedMeds(medications)

			setDailyMeds(dailyMeds)
			setUpdatedDailyMeds(dailyMeds)
		}
	}, [visit])

	const renderToolTip = (issues) => {
		return (
			<div style={{ display: 'flex', flexDirection: 'column' }}>
				{issues.map((i, index) => (
					<ToolTipItemPet key={index} message={i.message} color={i.color || null} />
				))}
			</div>
		)
	}

	const renderDogAlert = (pet) => {
		const issues = getDogIssues(pet, visit)
		return (
			<div style={{ marginLeft: '15px' }}>
				{issues && issues.length ? (
					<Tooltip title={renderToolTip(issues)}>
						<Chip
							label={<Warning style={{ fontSize: '15px' }} />}
							style={
								issues.some((i) => i.type === 'danger')
									? {
										...getChipStyles('rejected'),
										...{ paddingTop: '6px' }
									}
									: {
										...getChipStyles('warning'),
										...{ paddingTop: '6px' }
									}
							}
						/>
					</Tooltip>
				) : null}
			</div>
		)
	}

	const renderPetTitle = (pet) => (
		<div className={classes.petTitle}>
			<Link component={RouterLink} to={`/clients/${visit.household_id}/pets/${pet._id}`}>
				{pet.name}
			</Link>
			{isWelcomeDay && (
				<Icon className="fa fa-calendar" style={{ fontSize: 16, color: '#6B4AD6', marginLeft: 8 }} />
			)}
			<MuiThemeProvider theme={dogAlert}>{renderDogAlert(pet)}</MuiThemeProvider>
			{pet.status && (pet.status.checked_in || pet.status.checked_out) ? (
				<Chip
					className={classes.checkedInOutChip}
					label={pet.status.checked_in ? 'Checked In' : 'Checked Out'}
					style={getChipStyles(pet.status.checked_in ? 'Success' : null)}
				/>
			) : null}
		</div>
	)

	const getMedTimes = () => {
		if (pet.medication) {
			return pet.medication
				.filter((med) => med.active !== false && !visit.not_present_meds.includes(med._id))
				.map((med) => {
					let name = <Typography className={classes.titleText}>{med.name}</Typography>
					let times

					if (med.frequency === 'Custom' || med.frequency === 'As Needed') {
						let customVisitMeds =
							visit.medications && visit.medications.length
								? visit.medications.filter(
									(m) =>
										m.med_id === med._id &&
										(!m.frequency ||
											(m.frequency &&
												(m.frequency === 'Custom' || m.frequency === 'As Needed')))
								)
								: []

						customVisitMeds = groupBy(customVisitMeds, 'date')

						times = (
							<div
								style={{
									display: 'flex'
								}}>
								<Typography
									className={classes.infoText}
									style={{ textTransform: 'capitalize', marginRight: 4 }}>
									{`${med.frequency}${isEmpty(customVisitMeds) ? '' : ':'}`}
								</Typography>
								<div>
									{Object.keys(customVisitMeds).map((d) => (
										<Typography
											className={classes.infoText}
											style={{ textTransform: 'capitalize' }}>{`${moment(d).format(
												'MMM D'
											)}, ${customVisitMeds[d] && customVisitMeds[d].length
													? customVisitMeds[d].map((m) => m.time).join(', ')
													: ''
												}`}</Typography>
									))}
								</div>
							</div>
						)
					} else if (med.times_of_day && med.frequency === 'Daily') {
						let dailyVisitMed =
							visit.medications && visit.medications.length
								? visit.medications.find(
									(m) => m.frequency === med.frequency && m.med_id === med._id
								)
								: null

						times = (
							<Typography className={classes.infoText} style={{ textTransform: 'capitalize' }}>
								{dailyVisitMed
									? dailyVisitMed.frequency + ': ' + dailyVisitMed.times_of_day.join(', ')
									: med.frequency + ', ' + med.times_of_day.join(', ')}
							</Typography>
						)
					}

					return {
						name,
						times
					}
				})
		}
	}

	const getPetSize = () => {
		if (pet.height) return pet.height
		if (pet.weight <= 12) {
			return 'Extra-Small'
		} else if (pet.weight >= 13 && pet.weight < 31) {
			return 'Small'
		} else if (pet.weight >= 31 && pet.weight < 48) {
			return 'Medium'
		} else if (pet.weight >= 48 && pet.weight < 71) {
			return 'Large'
		} else if (pet.weight >= 71) {
			return 'Extra-Large'
		} else {
			return GROOMING_DEFAULT_EMPTY_VALUE
		}
	}

	const renderInventory = () => {
		return pet?.inventory?.length > 0
			? pet.inventory
				.filter((i) => i.pet_id == pet._id && i.facility_id == visit.facility_id)
				.map((item) => {
					return (
						<div className={classes.box} style={{ marginRight: '8px' }}>
							<Typography
								className={classes.titleText}
								style={{
									padding: '12px',
									textTransform: 'uppercase',
									color: '#4D4C4F',
									fontWeight: '800',
									fontSize: '12px'
								}}>
								{item.name}
							</Typography>
						</div>
					)
				})
			: null
	}

	const renderDaycareFood = () => {
		return visit.add_on_services.filter((addOn) => addOn.category === 'meal' && addOn.pet_id == pet._id)
			.length > 0
			? visit.add_on_services
				.filter((addOn) => addOn.category === 'meal' && addOn.pet_id == pet._id)
				.map((mealAddOn) => mealAddOn.time)
				.sort()
				.reverse()
				.join(', ')
			: '-'
	}

	const saveAddOn = (addOn) => {
		dispatch(updateVisitAddOns(addOn))
	}

	const getKennelType = () => {
		if (facility && visit) {
			let boarding_options = visit.boarding_options || []
			let option

			if (visit.sharing_kennels) {
				let pet_id = visit.pets && visit.pets.length ? visit.pets[0]._id : null

				let found =
					boarding_options && boarding_options.length
						? boarding_options.find((o) => o.pet_id === pet_id)
						: null

				option = found || null
			} else {
				option = boarding_options.find((o) => o.pet_id === pet._id)
			}

			return option && option.kennel_type
				? `${option.kennel_type}${visit.sharing_kennels ? ' - Shared' : ''}`
				: `Standard${visit.sharing_kennels ? ' - Shared' : ''}`
		} else {
			return null
		}
	}

	const getKennel = () => {
		if (facility && visit) {
			let { kennels } = facility

			let kennel = kennels.find((k) => {
				let pet_ids = k?.pet_ids || []

				return pet_ids.includes(pet._id)
			})

			return kennel ? kennel : null
		}

		return null
	}

	const renderKennel = () => {
		let kennel = getKennel()
		kennel = kennel && kennel.reference_number ? kennel.reference_number : GROOMING_DEFAULT_EMPTY_VALUE
		return <Typography className={classes.infoText}>{getKennelType() + ', ' + kennel}</Typography>
	}

	const getLocation = () => {
		if (facility && pet) {
			if (visit?.type === GROOMING) {
				if (visit.grooming_status === 'In Progress') return 'Grooming Room'
			}

			let { areas } = facility
			let area

			if (pet.status && pet.status.location && pet.status.location === 'resting') {
				let kennel = getKennel()

				if (kennel) area = areas.find((a) => a._id === kennel.area_id)

				return `Resting - ${kennel ? kennel.reference_number : 'No Kennel'}`
			} else {
				let playgroup = getPlaygroup()

				if (playgroup && playgroup.area_id) area = areas.find((a) => a._id === playgroup.area_id)
			}

			return area
				? `${area.name}`
				: `${pet.status && pet.status.location ? pet.status.location : GROOMING_DEFAULT_EMPTY_VALUE}`
		}

		return GROOMING_DEFAULT_EMPTY_VALUE
	}

	const getPlaygroup = () => {
		return pet.status && pet.status.playgroup && playgroups.find((p) => pet.status.playgroup == p._id)
			? playgroups.find((p) => pet.status.playgroup === p._id).name
			: null
	}

	const renderPlaygroup = () => {
		let playgroup = getPlaygroup()

		return <Typography className={classes.infoText}>{playgroup || GROOMING_DEFAULT_EMPTY_VALUE}</Typography>
	}

	const showEditMedPopup = (med) => {
		setSelectedMed(med)
		setIsEditMedShown(true)
	}

	const hideEditMedPopup = () => {
		setSelectedMed(null)
		setIsEditMedShown(false)
	}

	const saveAvailableMeds = (skipFirstMeds) => {
		let body = {
			visit_id: visit._id,
			updates: {}
		}

		let medications = updatedMeds
			.map((m) => {
				return m.time_blocks.map((t) => {
					let found = visit.medications.find(
						(vm) => vm.med_id === m.med_id && vm.date === m.date && vm.time === t
					)

					return (
						found || {
							name: m.name,
							med_id: m.med_id,
							pet_id: pet._id,
							date: m.date,
							time: t
						}
					)
				})
			})
			.flat(1)

		body.updates.medications = [...medications, ...updatedDailyMeds]

		let meds = [...visit.not_present_meds.filter((id) => !selectedMeds.map((med) => med._id).includes(id))]
		let petMeds = [
			...pet.medication
				.filter((med) => med.active !== false)
				.filter((med) => !selectedMeds.map((m) => m._id).includes(med._id))
				.map((med) => med._id)
		]

		let not_present_meds = [...new Set([...meds, ...petMeds])]

		if (notAvailableMeds) {
			body.updates = {
				...body.updates,
				not_present_meds
			}

			if (notAvailableMeds.length) {
				body.updates.medications = [
					...body.updates.medications.filter((m) => !notAvailableMeds.includes(m.med_id))
				]
			}
		}

		if (skipFirstMeds) {
			let meds = pet.medication
			meds = meds && meds.length ? meds.filter((m) => m.active !== false && m.frequency === 'Daily') : []

			body.updates.medsToSkip = meds.map((m) => {
				return {
					name: m.name,
					med_id: m._id,
					pet_id: pet._id,
					date: visit.dates && visit.dates.length ? visit.dates[0] : moment().format('YYYY-MM-DD'),
					time:
						m.times_of_day && m.times_of_day.length
							? m.times_of_day.sort()[m.times_of_day.length - 1]
							: 'morning'
				}
			})
		}

		dispatch(updateVisit(body, !isEqual(visitMeds, updatedMeds) || !isEqual(dailyMeds, updatedDailyMeds)))

		hideEditMedPopup()
	}

	const updateServiceType = (type) => {
		let body = {
			visit_id: visit._id,
			updates: {
				grooming_service_type: type
			}
		}

		dispatch(updateVisit(body, true))
	}

	const saveVisit = async (updates) => {
		let body = {
			visit_id: visit._id,
			updates: {
				...updates
			}
		}

		dispatch(updateVisit(body, true))

		// temporary (LOL hopefully) hack so these calls dont race each other
		setTimeout(async () => {
			if (updates.temp_file) {
				const data = new FormData()
				data.append('reference_photo', updates.temp_file)
				const updated = await api.put(`/uploadVisitImage/${visit._id}?type=reference_photo_url`, data)
				dispatch({
					type: 'UPDATE_VISIT_PHOTO',
					payload: { key: 'reference_photo_url', data: updated.data.reference_photo_url }
				})
			}

			if (updates.after_temp_file) {
				const data = new FormData()
				data.append('reference_photo', updates.after_temp_file)
				const updated = await api.put(`/uploadVisitImage/${visit._id}?type=after_photo_url`, data)
				dispatch({
					type: 'UPDATE_VISIT_PHOTO',
					payload: { key: 'after_photo_url', data: updated.data.after_photo_url }
				})
			}

			if (updates.before_temp_file) {
				const data = new FormData()
				data.append('reference_photo', updates.before_temp_file)
				const updated = await api.put(`/uploadVisitImage/${visit._id}?type=before_photo_url`, data)
				dispatch({
					type: 'UPDATE_VISIT_PHOTO',
					payload: { key: 'before_photo_url', data: updated.data.before_photo_url }
				})
			}
		}, 500)
	}

	let medTimes = getMedTimes()

	const getServiceType = () => {
		let type = 'Not Specified'
		const groomingServices = facility?.services?.grooming?.services || []

		if (visit?.grooming_service_type) {
			let ourType = groomingServices.find((g) => g.type === visit.grooming_service_type)
			if (ourType) type = ourType.name
			if (ourType?.type === 'bath') type = 'Bath & Towel Dry'
		}
		return type
	}

	const getDuration = () => {
		let type

		if (visit.duration) {
			type = +visit.duration
		} else {
			const groomingServices = facility?.services?.grooming?.services || []

			// auto calculate duration if not set by admin
			if (visit?.grooming_service_type) {
				let ourType = groomingServices.find((g) => g.type === visit.grooming_service_type)
				if (ourType) type = ourType.duration
			}

			if (pet?.extra_groom_time && type) type += pet.extra_groom_time
		}

		return type ? `${type} min` : GROOMING_DEFAULT_EMPTY_VALUE
	}

	const getPreferredGroomer = () => {
		if (!visit.preferred_staff_id) return GROOMING_DEFAULT_EMPTY_VALUE
		let staff = staffList?.find((s) => s._id === visit.preferred_staff_id)
		return staff ? `${staff.contact.first_name} ${staff.contact.last_name}` : GROOMING_DEFAULT_EMPTY_VALUE
	}

	const getAssignedGroomer = () => {
		if (!visit.staff_id) return GROOMING_DEFAULT_EMPTY_VALUE
		let staff = staffList?.find((s) => s._id === visit.staff_id)
		return staff ? `${staff.contact.first_name} ${staff.contact.last_name}` : GROOMING_DEFAULT_EMPTY_VALUE
	}

	const getQuotedPriceRange = () => {
		let min = visit.quoted_price_min ? (visit.quoted_price_min / 100).toFixed(2) : null
		let max = visit.quoted_price_max ? (visit.quoted_price_max / 100).toFixed(2) : null

		if (min || max) return `${min || GROOMING_DEFAULT_EMPTY_VALUE} - ${max || GROOMING_DEFAULT_EMPTY_VALUE}`
		return GROOMING_DEFAULT_EMPTY_VALUE
	}

	const getAllowedServices = () => {
		const groomingServices = facility?.services?.grooming?.services || []

		if (pet?.allowed_grooming_services?.length) {
			return pet.allowed_grooming_services
				.map((s) => {
					return groomingServices.find((gs) => gs.type === s)
				})
				.filter(Boolean)
				.map((s) => s.name)
				.join(', ')
		}

		return GROOMING_DEFAULT_EMPTY_VALUE
	}

	const getAllowedAddOns = () => {
		if (pet?.grooming_addons?.length && facility?.addOnTypes) {
			return pet.grooming_addons
				.map((s) => {
					return facility.addOnTypes.find((gs) => gs.grooming_addon_type === s)
				})
				.filter(Boolean)
				.map((s) => s.name)
				.join(', ')
		}

		return GROOMING_DEFAULT_EMPTY_VALUE
	}

	const petCubbies = useMemo(() => {
		if (pet && visit && visit.cubbies && visit.cubbies.length) {
			const cubbies = visit.cubbies.find((cub) => String(cub.pet_id) === String(pet._id)) || {}
			return cubbies
		}

		return {}
	}, [visit, pet])

	const petCubbiesFormatted = useMemo(() => {
		const { gear, food, boarding, medication } = petCubbies
		const {
			gear: gearFac,
			food: foodFac,
			boarding: boardingFac,
			medication: medicationFAc
		} = facility?.cubbies || {}
		const cubs = []
		if (gear) {
			cubs.push(`${gearFac?.prefix || 'G'}${gear}`)
		}
		if (food) {
			cubs.push(`${foodFac?.prefix || 'F'}${food}`)
		}
		if (medication) {
			cubs.push(`${medicationFAc?.prefix || 'M'}${medication}`)
		}
		if (boarding) {
			cubs.push(`${boardingFac?.prefix || 'B'}${boarding}`)
		}

		if (cubs.length) return cubs.join(', ')

		const stat = visit?.pet_status || []

		const ourStat = stat.find((s) => s.pet_id == pet._id)

		if (ourStat?.cubby) return ourStat.cubby

		return '--'
	}, [petCubbies, facility, visit])

	const groomAdds = facility?.addOnTypes?.filter((a) => a.grooming_service) || []

	return (
		<Card>
			<CardHeader
				className={classes.cardHeader}
				avatar={
					<Avatar
						alt={pet.name}
						src={
							pet.profile_image_file_name
								? `https://waggle-keys-prod.s3.amazonaws.com/${pet.profile_image_file_name}`
								: null
						}>
						{getAvatarLetters(pet.name)}
					</Avatar>
				}
				title={renderPetTitle(pet)}
			/>
			<CardContent>
				<div className={[classes.box]}>
					<div className={classes.boxHeader}>
						<Typography variant="overline">Related Appointments</Typography>
					</div>
					<RelatedVisitsTable
						household={household}
						pet={pet}
						related_visits={visit.related_visits}
						visit={visit}
					/>
				</div>

				{visit?.type === GROOMING && (
					<>
						<div className={classes.box}>
							<div className={classes.boxHeader}>
								<Typography variant="overline">Grooming Service</Typography>
								<Button onClick={() => setIsServiceShown(true)}>
									<Typography className={classes.editButton}>Edit</Typography>
								</Button>
							</div>
							<div className={classes.rowInt}>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText}>
										Sub-Service Type
									</Typography>
								</div>
								<div className={classes.rowRow}>
									<Typography
										variant="body1"
										className={classes.serviceText2}
										style={{ textTransform: 'capitalize' }}>
										{getServiceType()}
									</Typography>
								</div>
							</div>
							<div style={{ paddingLeft: 16, paddingRight: 16 }}>
								{visit &&
									visit.dates &&
									visit.dates.length &&
									visit.dates.map((date) => (
										<GroomingAddOnDropdown
											key={date}
											grooming={true}
											date={moment(date).format('MMM D, YYYY')}
											visit={visit}
											pet={pet}
											facility={facility}
											setIsAddAddonShown={(d) => setIsShown(d ? date : false)}
										/>
									))}
							</div>
						</div>

						<div className={classes.box}>
							<div className={classes.boxHeader}>
								<Typography variant="overline">Grooming Specifics</Typography>
								<Button onClick={() => setIsEditGroomingShown(true)}>
									<Typography className={classes.editButton}>Edit</Typography>
								</Button>
							</div>
							<div className={classes.rowInt}>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText}>
										Scheduled Start Time
									</Typography>
								</div>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText2}>
										{visit?.start_time
											? moment(visit.start_time, 'HH:mm').format('h:mm A')
											: GROOMING_DEFAULT_EMPTY_VALUE}
									</Typography>
								</div>
							</div>
							<div className={classes.rowInt}>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText}>
										Expected Duration
									</Typography>
								</div>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText2}>
										{getDuration()}
									</Typography>
								</div>
							</div>
							<div className={classes.rowInt}>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText}>
										Preferred Groomer
									</Typography>
								</div>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText2}>
										{getPreferredGroomer()}
									</Typography>
								</div>
							</div>
							<div className={classes.rowInt}>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText}>
										Assigned Groomer
									</Typography>
								</div>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText2}>
										{getAssignedGroomer()}
									</Typography>
								</div>
							</div>
							<div className={classes.rowInt}>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText}>
										Current Hair Length
									</Typography>
								</div>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText2}>
										{visit.hair_length || GROOMING_DEFAULT_EMPTY_VALUE}
									</Typography>
								</div>
							</div>
							<div className={classes.rowInt}>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText}>
										Trim Amount
									</Typography>
								</div>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText2}>
										{visit.trim_amount || GROOMING_DEFAULT_EMPTY_VALUE}
									</Typography>
								</div>
							</div>
							<div className={classes.rowInt}>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText}>
										Matted Coat
									</Typography>
								</div>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText2}>
										{visit.matted || GROOMING_DEFAULT_EMPTY_VALUE}
									</Typography>
								</div>
							</div>
							<div className={classes.rowInt}>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText}>
										Quoted Price Range
									</Typography>
								</div>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText2}>
										${getQuotedPriceRange()}
									</Typography>
								</div>
							</div>
							<div className={classes.rowInt}>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText}>
										Actual Price
									</Typography>
								</div>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText2}>
										$
										{visit.price
											? (visit.price / 100).toFixed(2)
											: GROOMING_DEFAULT_EMPTY_VALUE}
									</Typography>
								</div>
							</div>
							<div className={classes.rowInt}>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText}>
										Notes from Team
									</Typography>
								</div>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText2}>
										{visit.notes_from_team || GROOMING_DEFAULT_EMPTY_VALUE}
									</Typography>
								</div>
							</div>
							<div className={classes.rowInt}>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText}>
										Notes from Client
									</Typography>
								</div>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText2}>
										{visit.notes_from_client || GROOMING_DEFAULT_EMPTY_VALUE}
									</Typography>
								</div>
							</div>
							<div className={classes.rowInt}>
								<div className={classes.rowRow}>
									<Typography variant="body1" className={classes.serviceText}>
										Reference Photo
									</Typography>
								</div>
								<div className={classes.rowRow}>
									{visit.reference_photo_url ? (
										<Button
											variant="text"
											style={{
												color: '#6B4AD6'
											}}
											onClick={() => {
												setPhotoType('Reference Photo')
												setPhotoUrl(visit.reference_photo_url)
												showRefPhoto(true)
											}}>
											[Link]
										</Button>
									) : (
										GROOMING_DEFAULT_EMPTY_VALUE
									)}
								</div>
							</div>
						</div>

						<div className={classes.box} style={{ padding: 16, paddingTop: 0 }}>
							<Collapse in={showGroomTable} collapsedSize={53}>
								{household?._id === visit?.household_id ? (
									<GroomingDurationTable
										facilityOverride={visitFacility}
										facility={visitFacility}
										household={household}
										toggle={() => setShowGroomTable(!showGroomTable)}
										open={showGroomTable}
										pet={pet}
										prices={groomingPrices || {}}
										addons={groomAdds}
									/>
								) : (
									<div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: 16 }}>
										<CircularProgress size={16} />
										<Typography>Loading grooming pricing…</Typography>
									</div>
								)}
							</Collapse>
						</div>
					</>
				)}
				<div className={classes.box}>
					<div className={classes.boxHeader}>
						<Typography variant="overline">Assignments</Typography>
						<Button onClick={() => setIsEditAssignmentsShown(true)}>
							<Typography className={classes.editButton}>Edit</Typography>
						</Button>
					</div>
					<div className={classes.row}>
						<div className={classes.section}>
							<div className={classes.sectionHeading}>
								<Typography className={classes.titleText}>Current Location</Typography>
								<Typography className={classes.titleText}>Playgroup</Typography>
								<Typography className={classes.titleText}>{`${visit.type === 'boarding' ? 'Night Kennel' : 'Kennel'
									}`}</Typography>
								<Typography
									style={{
										color: '#1A1A35',
										fontSize: '16px',
										fontWeight: '600px'
									}}>
									Cubby Assignments
								</Typography>
							</div>
						</div>
						<div className={classes.section}>
							<div className={classes.sectionHeading}>
								<Typography className={classes.infoText} style={{ textTransform: 'capitalize' }}>
									{getLocation()}
								</Typography>
								{renderPlaygroup()}
								{renderKennel()}
								<Typography
									style={{
										color: '#4D4C4F',
										fontSize: '16px',
										fontWeight: '600px'
									}}>
									{petCubbiesFormatted}
								</Typography>
							</div>
						</div>
					</div>
				</div>
				{visit?.type !== GROOMING && !isAddonOnlyVisit && (
					<div className={classes.box}>
						<div className={classes.boxHeader}>
							<Typography variant="overline">Food</Typography>
							<Button onClick={() => setIsEditFoodShown(true)}>
								<Typography className={classes.editButton}>Edit</Typography>
							</Button>
						</div>
						<div className={classes.row}>
							<div className={classes.section}>
								<div className={classes.sectionHeading}>
									<Typography className={classes.titleText}>Daily Meals</Typography>
								</div>
							</div>
							<div
								className={classes.section}
								style={{
									marginRight: '120px',
									width:
										visit.type === 'boarding' && pet.food_schedule.length == 0
											? '300px'
											: '210px'
								}}>
								<div className={classes.sectionHeading}>
									<Typography
										className={classes.infoText}
										style={{ textTransform: 'capitalize' }}>
										{visit.type === 'boarding'
											? pet.food_schedule.length > 0
												? pet.food_schedule.sort().reverse().join(', ')
												: 'Food schedule not specified for pet'
											: renderDaycareFood()}
									</Typography>
								</div>
							</div>
						</div>
					</div>
				)}

				{visit?.type !== GROOMING && !isAddonOnlyVisit && (
					<div className={classes.box}>
						<div className={classes.boxHeader}>
							<Typography variant="overline">Available Meds</Typography>
							<Button onClick={() => setIsEditMedsShown(true)}>
								<Typography className={classes.editButton}>Edit</Typography>
							</Button>
						</div>

						<div className={classes.row}>
							<div className={classes.section} style={{ width: '100%' }}>
								{medTimes && medTimes.length ? (
									<MaterialTable
										style={{
											boxShadow: 'none'
										}}
										options={{
											header: false,
											showTitle: false,
											search: false,
											paging: false,
											rowStyle: {
												border: 'none'
											},
											headerStyle: {
												display: 'none'
											},
											toolbar: false
										}}
										columns={[
											{
												title: 'Name',
												field: 'name',
												width: 210,
												cellStyle: {
													verticalAlign: 'top',
													width: 211,
													padding: 0,
													border: 'none'
												}
											},
											{
												title: 'Times',
												field: 'times',
												cellStyle: {
													padding: 0,
													border: 'none'
												}
											}
										]}
										data={medTimes}
									/>
								) : (
									<Typography className={classes.infoText} style={{ color: '#777679' }}>
										No meds have been made available
									</Typography>
								)}
							</div>
						</div>
					</div>
				)}

				<div className={classes.box}>
					<div className={classes.boxHeader}>
						<Typography variant="overline"> Inventory </Typography>
						<Button onClick={() => setIsEditInventoryShown(true)}>
							<Typography className={classes.editButton}>Edit</Typography>
						</Button>
					</div>
					<div className={classes.row}>
						<div className={classes.section} style={{ width: renderInventory() ? '210px' : '100%' }}>
							<div className={classes.sectionHeading}>
								<div style={{ display: 'flex' }}>
									{pet.inventory && renderInventory() ? (
										renderInventory()
									) : (
										<Typography className={classes.titleText} style={{ color: '#777679' }}>
											No inventory items have been documented
										</Typography>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>

				{visit?.type === GROOMING && (
					<div className={classes.box}>
						<div className={classes.boxHeader}>
							<Typography variant="overline">Pet Information</Typography>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Size
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{getPetSize()}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Age
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{getPetAge(pet?.birthday) || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Sex
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{pet.sex || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Breed Mix
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography
									variant="body1"
									className={classes.serviceText2}
									style={{ textTransform: 'capitalize' }}>
									{pet.breed_mix || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Breed
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{(pet?.breeds && pet?.breeds.join(', ')) || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Coat Length
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography
									variant="body1"
									className={classes.serviceText2}
									style={{ textTransform: 'capitalize' }}>
									{pet.coat_length || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Coat Type
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{pet.coat_type || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Ear Cleaning
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography
									variant="body1"
									className={classes.serviceText2}
									style={{ textTransform: 'capitalize' }}>
									{pet.ear_cleaning || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Nail Trim
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography
									variant="body1"
									className={classes.serviceText2}
									style={{ textTransform: 'capitalize' }}>
									{pet.nail_trimming || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Anal Glands
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography
									variant="body1"
									className={classes.serviceText2}
									style={{ textTransform: 'capitalize' }}>
									{pet.glands || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Shedding
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography
									variant="body1"
									className={classes.serviceText2}
									style={{ textTransform: 'capitalize' }}>
									{pet.shedding || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Sensitive Body Parts
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{petSensitivityTags?.length
										? petSensitivityTags.map((p) => p.name).join(', ')
										: GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						{/*<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Grooming Level
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{pet.grooming_level || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>*/}
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Extra Groom Time
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{pet.extra_groom_time || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Allowed Sub Services
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography
									variant="body1"
									className={classes.serviceText2}
									style={{ textTransform: 'capitalize' }}>
									{getAllowedServices()}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Recommended Enrichments
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{getAllowedAddOns()}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Grooming Tags
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{petGroomingTags?.length
										? petGroomingTags.map((p) => p.name).join(', ')
										: GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Groomer Notes
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{pet?.team_grooming_notes || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Client Notes
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{pet?.client_grooming_notes || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
					</div>
				)}

				{visit?.type === GROOMING && (
					<div className={classes.box}>
						<div className={classes.boxHeader}>
							<Typography variant="overline">Report</Typography>
							<Button onClick={() => setIsGroomingReportShown(true)}>
								<Typography className={classes.editButton}>Edit</Typography>
							</Button>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Check-In Time
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{visit?.checkin_time
										? moment(visit.checkin_time).format('h:mm A')
										: GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Actual Start Time
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{visit?.grooming_actual_start_time
										? moment(visit.grooming_actual_start_time).format('h:mm A')
										: GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Actual End Time
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{visit?.grooming_actual_end_time
										? moment(visit.grooming_actual_end_time).format('h:mm A')
										: GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Actual Duration
								</Typography>
							</div>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText2}>
									{visit?.grooming_running_time ? `${visit.grooming_running_time} min` : 'N/A'}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Team Report Notes
								</Typography>
							</div>
							<div className={classes.rowRow2}>
								<Typography variant="body1" className={classes.serviceText2OneLine} noWrap={true}>
									{visit?.grooming_team_report_notes || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Behavior Notes
								</Typography>
							</div>
							<div className={classes.rowRow2}>
								<Typography variant="body1" className={classes.serviceText2OneLine} noWrap={true}>
									{visit?.behavior_notes || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Client Report Notes
								</Typography>
							</div>
							<div className={classes.rowRow2}>
								<Typography variant="body1" className={classes.serviceText2OneLine} noWrap={true}>
									{visit?.grooming_client_report_notes || GROOMING_DEFAULT_EMPTY_VALUE}
								</Typography>
							</div>
						</div>

						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									Before Photo
								</Typography>
							</div>
							<div className={classes.rowRow}>
								{visit.before_photo_url ? (
									<Button
										variant="text"
										style={{
											color: '#6B4AD6'
										}}
										onClick={() => {
											setPhotoType('Before Photo')
											setPhotoUrl(visit.before_photo_url)
											showRefPhoto(true)
										}}>
										[Link]
									</Button>
								) : (
									GROOMING_DEFAULT_EMPTY_VALUE
								)}
							</div>
						</div>
						<div className={classes.rowInt}>
							<div className={classes.rowRow}>
								<Typography variant="body1" className={classes.serviceText}>
									After Photo
								</Typography>
							</div>
							<div className={classes.rowRow}>
								{visit.after_photo_url ? (
									<Button
										variant="text"
										style={{
											color: '#6B4AD6'
										}}
										onClick={() => {
											setPhotoType('Before Photo')
											setPhotoUrl(visit.after_photo_url)
											showRefPhoto(true)
										}}>
										[Link]
									</Button>
								) : (
									GROOMING_DEFAULT_EMPTY_VALUE
								)}
							</div>
						</div>
					</div>
				)}

				<div>
					{visit && visit.dates && visit.dates.length
						? visit.dates.map((date) => (
							<VisitPetDetailDayDropdown
								key={date}
								date={moment(date).format('MMM D, YYYY')}
								visit={visit}
								pet={pet}
								setIsAddAddonShown={(d) => setIsShown(d ? date : false)}
							/>
						))
						: 'No dates to display.'}
				</div>
				<div>
					<StaffNotesVisit visit={visit} pet={pet} />
				</div>
				{pet?.notes > '' ? (
					<div>
						<ClientNotes notes={pet?.notes} />
					</div>
				) : null}
			</CardContent>
			<PhotoDialog isShown={refPhoto} photoType={photoType} photoUrl={photoUrl} setIsShown={showRefPhoto} />
			<ApplyAddOnDialog
				isShown={isShown}
				setIsShown={setIsShown}
				saveAddOn={saveAddOn}
				pet={pet}
				date={isShown}
			/>
			<GroomingReportDialog
				isShown={isGroomingReportShown}
				setIsShown={setIsGroomingReportShown}
				saveVisit={saveVisit}
				visit={visit}
				pet={pet}
			/>
			<GroomingDialog
				isShown={isGroomingEditShown}
				setIsShown={setIsEditGroomingShown}
				saveVisit={saveVisit}
				staffList={staffList}
				facility={facility}
				pet={pet}
				visit={visit}
			/>
			<GroomingServiceDialog
				isShown={isServiceShown}
				setIsShown={setIsServiceShown}
				facility={facility}
				updateServiceType={updateServiceType}
				pet={pet}
				visit={visit}
			/>
			<EditAssignmentsDialog
				isShown={isEditAssignmentsShown}
				setIsShown={setIsEditAssignmentsShown}
				facility={facility}
				visits={props.visits}
				pet={pet}
				visit={visit}
				cubbies={petCubbies}
			/>
			<EditFoodDialog isShown={isEditFoodShown} setIsShown={setIsEditFoodShown} pet={pet} visit={visit} />
			<EditMedsDialog
				isShown={isEditMedsShown}
				setIsShown={setIsEditMedsShown}
				showEditMedPopup={showEditMedPopup}
				pet={pet}
				visit={visit}
				selectedMeds={selectedMeds}
				setSelectedMeds={setSelectedMeds}
				initialMeds={initialMeds}
				setInitialMeds={setInitialMeds}
				setNotAvailableMeds={setNotAvailableMeds}
				saveAvailableMeds={saveAvailableMeds}
			/>
			<EditMedDialog
				isShown={isEditMedShown}
				showEditMedPopup={showEditMedPopup}
				hideEditMedPopup={hideEditMedPopup}
				med={selectedMed}
				pet={pet}
				visit={visit}
				saveMedsToVisit={saveAvailableMeds}
				visitMeds={visitMeds}
				setVisitMeds={setVisitMeds}
				updatedMeds={updatedMeds}
				setUpdatedMeds={setUpdatedMeds}
				dailyMeds={dailyMeds}
				setDailyMeds={setDailyMeds}
				updatedDailyMeds={updatedDailyMeds}
				setUpdatedDailyMeds={setUpdatedDailyMeds}
			/>
			<EditInventoryDialog
				isShown={isEditInventoryShown}
				setIsShown={setIsEditInventoryShown}
				pet={pet}
				visit={visit}
			/>
		</Card>
	)
}

export default VisitPetDetail
